import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';

export default function NotFound(): ReactElement {
  return (
    <main className="grid flex-1 place-items-center overflow-y-auto overscroll-contain px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 dark:text-neutral-100 sm:text-5xl">
          Not Found
        </h1>
        <p className="mt-6 text-base leading-7 text-gray-600 dark:text-neutral-500">
          There’s no page at this address! <br />
          Please check the URL and try again. Alternatively you can go to {' '}
          <Link to="/" className="text-blue-600 underline">
            home
          </Link>.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6"></div>
      </div>
    </main>
  );
}
